__turbopack_context__.v({
  "backTransparent": "index-module-scss-module__lgQGVG__backTransparent",
  "black": "index-module-scss-module__lgQGVG__black",
  "blue": "index-module-scss-module__lgQGVG__blue",
  "blueText": "index-module-scss-module__lgQGVG__blueText",
  "body": "index-module-scss-module__lgQGVG__body",
  "borderBlue": "index-module-scss-module__lgQGVG__borderBlue",
  "borderGradient": "index-module-scss-module__lgQGVG__borderGradient",
  "borderGrey": "index-module-scss-module__lgQGVG__borderGrey",
  "borderWhite": "index-module-scss-module__lgQGVG__borderWhite",
  "circle": "index-module-scss-module__lgQGVG__circle",
  "disabled": "index-module-scss-module__lgQGVG__disabled",
  "fontLarge": "index-module-scss-module__lgQGVG__fontLarge",
  "fontMedium": "index-module-scss-module__lgQGVG__fontMedium",
  "fontSmall": "index-module-scss-module__lgQGVG__fontSmall",
  "goldBordered": "index-module-scss-module__lgQGVG__goldBordered",
  "goldGradient": "index-module-scss-module__lgQGVG__goldGradient",
  "gradient": "index-module-scss-module__lgQGVG__gradient",
  "grey": "index-module-scss-module__lgQGVG__grey",
  "icon": "index-module-scss-module__lgQGVG__icon",
  "invertSvg": "index-module-scss-module__lgQGVG__invertSvg",
  "phoneWide": "index-module-scss-module__lgQGVG__phoneWide",
  "purpleText": "index-module-scss-module__lgQGVG__purpleText",
  "root": "index-module-scss-module__lgQGVG__root",
  "spinner": "index-module-scss-module__lgQGVG__spinner",
  "spinnerVisible": "index-module-scss-module__lgQGVG__spinnerVisible",
  "svg24": "index-module-scss-module__lgQGVG__svg24",
  "svg32": "index-module-scss-module__lgQGVG__svg32",
  "text": "index-module-scss-module__lgQGVG__text",
  "white": "index-module-scss-module__lgQGVG__white",
  "whitePurple": "index-module-scss-module__lgQGVG__whitePurple",
  "whiteText": "index-module-scss-module__lgQGVG__whiteText",
  "whiteTransparent": "index-module-scss-module__lgQGVG__whiteTransparent",
  "wide": "index-module-scss-module__lgQGVG__wide",
});
